import React, { Component } from "react";
import { Container, Button, Modal, Form} from "react-bootstrap";
import Select from 'react-select';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faEye, faEyeSlash, faRobot} from "@fortawesome/free-solid-svg-icons";
import { m } from "framer-motion";
import PasswordGenerator from "../../../managers/PasswordGenerator";
import { Tooltip } from "@chakra-ui/react";

import ConfigService from "../../../services/ConfigService";





function cleanValue(val) {
    return (val) ? val.trim() : "";
}


export default class ModalUserDialog extends Component 
{

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            isWorking: false,
            userId: "",
            userIdErr: "",
            userName: "",
            userPwd: "",
            userPwd2: "",
            userNameErr: "",
            userDescript: "",
            userDescriptErr: "",
            userPwdErr: "",
            userRolesErr: "",
            userLocationsErr: "",
            userSchemasErr: "",
            passwordSelectable: true,
            passwordEditable: false,
            passwordType: "password",
            passwordShowLabel: "show",
            selectedLocations: [],
            selectedRoles: [],
            selectedSchemas: []
        }

        this.configService = new ConfigService();

        this.clearDialog = this.clearDialog.bind(this);
        this.initDialog = this.initDialog.bind(this);
        this.onFormValueChange = this.onFormValueChange.bind(this);

        this.onLocationValueChange = this.onLocationValueChange.bind(this);
        this.onRoleValueChange = this.onRoleValueChange.bind(this);
        this.onSchemaValueChange = this.onSchemaValueChange.bind(this);

        this.toRoleValues = this.toRoleValues.bind(this);
        this.toLocationValues = this.toLocationValues.bind(this);
        this.toSchemaValues = this.toSchemaValues.bind(this);

        this.validate = this.validate.bind(this);
        this.postUser = this.postUser.bind(this);
        this.cancel = this.cancel.bind(this);


        this.userExists = this.userExists.bind(this);
        this.onResetPasswordClick = this.onResetPasswordClick.bind(this);
        this.togglePasswordShow = this.togglePasswordShow.bind(this);
        this.toSysGeneratedPassword = this.toSysGeneratedPassword.bind(this);


    }

    async componentDidMount()
    {
        this.clearDialog();
    }

     async componentDidUpdate(prevProps, prevState) {
        if (prevProps.showNewModal !== this.props.showNewModal) {
            if ((this.props.showNewModal)  && (this.props.editMode === "update"))
            {
                await this.initDialog();
            }
        }
    }

    clearDialog()
    {
        console.log("Clearing User Dialog values...")
        this.setState({
            userIdErr: "",
            userNameErr: "",
            userDescriptErr: "",
            userRolesErr: "",
            userLocationsErr: "",
            userSchemasErr: "",

            userPwdErr: "",
            passwordSelectable: true,
            passwordEditable: false,
            isWorking: false,
            userId: "",
            userName: "",
            userDescript: "",
            userPwd: "",
            userPwd2: "",

            selectedRoles: [],
            selectedLocations: [],
            selectedSchemas: []

        });
    }

    async sleep(ms) {
        await new Promise(r => setTimeout(r, ms));
      }

    async initDialog() {
        // clear out state values
        if (this.props.editMode === "update") 
        {
            console.log("Initializing User Dialog values for Edit...")
            // update. Set the values
            this.setState(
                {
                    userId: this.props.currentUser.clientId,
                    userName: this.props.currentUser.clientName,
                    userDescript: this.props.currentUser.description,
                    userPwd: this.props.currentUser.secret,
                    userPwd2: this.props.currentUser.secret,
                    selectedRoles: Array.isArray(this.props.currentUser.roles) ? this.toRoleValues() : [],
                    selectedLocations: Array.isArray(this.props.currentUser.locations) ? this.toLocationValues(): [],
                    selectedSchemas: Array.isArray(this.props.currentUser.listProperties?.schemas) ? this.toSchemaValues(): [],
                    passwordSelectable: true,
                    passwordEditable: false
                }
            );
        }
        else
        {
            console.log("Clearing User Dialog values for " + this.props.editMode + "...");
            //this.clearDialog();
            this.setState(
                {
                    userId: "",
                    userName: "",
                    userDescript: "",
                    userPwd: "",
                    userPwd2: "",
                    selectedRoles: [],
                    selectedLocations:  [],
                    selectedSchemas: [],
                    passwordSelectable: true,
                    passwordEditable: true
                }
            );
        }
        await this.sleep(1000);

    }

    async cancel(e)
    {
        await this.clearDialog();
        this.props.closeNewModal();
    }

    onFormValueChange(e) {
        console.log("Form change: ");
        console.log("id: " + e.target.id);
        console.log("value: " + e.target.value);
        this.setState({ [e.target.id]: e.target.value })
    }


    onRoleValueChange(opts) {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({
            selectedRoles: opts
        })
    }


    onLocationValueChange(opts) {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({selectedLocations: opts})
    }

    onSchemaValueChange(opts)
    {
        this.setState({selectedSchemas: opts})
    }

    onResetPasswordClick(checked) {
        if (!checked) {
            // reset password values
            this.setState({
                userPwd: this.props.currentUser.secret,
                userPwd2: this.props.currentUser.secret,
            });

        }
        this.setState({ passwordEditable: checked });
    }

    togglePasswordShow() {
        let lbl = this.state.passwordShowLabel;
        if (lbl === "show") {
            this.setState({
                passwordShowLabel: "hide",
                passwordType: "text"
            });
        } else {
            this.setState({
                passwordShowLabel: "show",
                passwordType: "password"
            });
        }
    }

    validate(user) {
        var userIdErr = (user.clientId === "") ? "*You must enter a User Id" : "";
        userIdErr = (user.clientId !== "" && user.clientId.length < 6) ? "* Your id must be at least 6 characters" : userIdErr;
        if (!userIdErr)
        {
            userIdErr = (user.clientId.toLowerCase().includes("super.admin")) ? "This is a reserved User Id. Please select another Id.": userIdErr;
        }
        if (!userIdErr)
        {
            // confirm the id is not in the list of reserved Ids.
            var sysUsersList = this.configService.getSystemUsers();
            userIdErr = (sysUsersList.some((s) => s.toLowerCase() === user.clientId.toLowerCase())) ? "This is a reserved User Id. Please select another Id.": userIdErr;
        }
        var userRolesErr = (user.roles.length < 1) ? "*You must select at least one role for this user" : "";
        var userLocationsErr = (user.locations.length < 1) ? "*You must select at least one location for this user" : "";
        var userSchemasErr = (user.schemas.length < 1)? "*You must select at least one schema for this user" : "";
        var userNameErr = "";
        var userDescriptErr = "";
        var userPwdErr = "";
        if (this.state.passwordEditable) {
            if ((user.password === "") || (this.state.userPwd2 === "")) {
                userPwdErr = "You must enter your password twice.";
            }
            else if (user.password !== this.state.userPwd2) {
                userPwdErr = "Please make sure your password entries match.";
            }
            else if (user.password.includes("**")) {
                userPwdErr = "To change the password, enter actual values in the password fields";
            }
            else if (user.password.length < 6) {
                userPwdErr = "Your password must be at least 6 characters";
            }
        }

        if (this.props.editMode === "add" && this.userExists(user.clientId)) {
            userIdErr = "A User with Id " + user.clientId + " already exists!";
        }

        this.setState(
            {
                userIdErr: userIdErr,
                userNameErr: userNameErr,
                userDescriptErr: userDescriptErr,
                userRolesErr: userRolesErr,
                userLocationsErr: userLocationsErr,
                userSchemasErr: userSchemasErr,
                userPwdErr: userPwdErr
            }
        )

        return ((userIdErr === "") && (userNameErr === "") && (userDescriptErr === "")
            && (userRolesErr === "") && (userLocationsErr === "") && (userSchemasErr === "") 
            && (userPwdErr === ""));
    }



    async postUser() {
        this.setState({ isWorking: true });
        // validate
        var gcid = (this.props.userSession) ? this.props.userSession.gcid : "";
        var app = (this.props.userSession) ? this.props.userSession.app : "";
        var clientName = cleanValue(this.state.userName);
        var descript = cleanValue(this.state.userDescript);
        var user = {
            "clientId": (this.props.editMode === "add") ? this.state.userId : this.props.currentUser.clientId, // new
            "gcid": gcid,
            "clientName": clientName,
            "description": descript,
            "password": (this.state.passwordEditable) ? this.state.userPwd : "", // empty the password so api knows we don't want it changed.
            "roles": (Array.isArray(this.state.selectedRoles) ? this.state.selectedRoles.map(d => d.value) : []),
            "locations": (Array.isArray(this.state.selectedLocations) ? this.state.selectedLocations.map(d => d.value) : []),
            "schemas": (Array.isArray(this.state.selectedSchemas) ? this.state.selectedSchemas.map(d => d.value) : []),
            "app": app
        };
        if (!this.validate(user)) {
            this.setState({ isWorking: false });
            return;
        }

        var postResult = (this.props.editMode === "add") ?
            await this.props.postNew(user)
            : await this.props.postUpdated(user);

        // clear out the dialog now
        await this.clearDialog();

        this.setState({ isWorking: false });
    }

    toRoleValues() 
    {
        var filtered = this.props.roles.filter(nd => this.props.currentUser.roles.indexOf(nd.id) >= 0);
        var result = filtered.map(d => {
            return {label: d.name, value: d.id}
        }
        );
        console.log("User Prop Roles:");
        console.info(this.props.currentUser.roles);
        console.log("This props roles available:");
        console.info(this.props.roles);
        console.log("User default roles:");
        console.info(result);
        return result;
    }

    toLocationValues() 
    {
        var filtered = this.props.locations.filter(nd => this.props.currentUser.locations.indexOf(nd.id) >= 0);
        var result = filtered.map(d => {
            return {label: d.name, value: d.id}
        }
        );
        return result;
    }

    toSchemaValues() 
    {
        var filtered = this.props.schemas.filter(nd => this.props.currentUser.listProperties?.schemas.indexOf(nd.id) >= 0);
        var result = filtered.map(d => {
            return {label: d.name, value: d.id}
        }
        );
        return result;
    }


    userExists(userId) {
        var lUserId = userId.toLowerCase();
        for (var i = 0; i < this.props.gridData.length; i++) {
            if (this.props.gridData[i].clientId.toLowerCase() === lUserId) {
                return true;
            }
        }
        return false;
    }

    toSysGeneratedPassword()
    {
        var result = PasswordGenerator.makePassPhrase();
        this.setState({
            userPwd: result, 
            userPwd2: result, 
            passwordShowLabel: "hide",
            passwordType: "text"
        });

    }

    render() {


        const workingButtonIcon = this.state.isWorking ? (
            <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
        ) : (
            "Ok"
        );

        const passwordCheckbox = (this.state.passwordSelectable) ?
            <Form.Check type="checkbox" label="Reset Password" onClick={e => this.onResetPasswordClick(e.target.checked)} /> : <span />;

        const showIcon = (this.state.passwordShowLabel === "show") ? faEye : faEyeSlash;
        const showIconTip = (this.state.passwordShowLabel === "show") ? "show password" : "hide password";

        const showPasswordButton = (this.state.passwordEditable) ?
            <Button
                variant="outline-secondary"
                onClick={this.togglePasswordShow}>
                <Tooltip label={showIconTip} area-label={showIconTip}>
                    <FontAwesomeIcon icon={showIcon} />
                </Tooltip>
            </Button> : <span />;

        const showPasswordGenerator = (this.state.passwordEditable) ?
            <Button
                variant="outline-secondary"
                size="small"
                onClick={(e) => this.toSysGeneratedPassword(e)}>
                <Tooltip label={"System-generated password"} area-label="System generated password">
                    <FontAwesomeIcon icon={faRobot} />
                </Tooltip>
                
            </Button> : <span />;


        return (
            <Modal
                show={this.props.showNewModal}
                onHide={this.cancel}
            >
                <Modal.Header closeButton>
                    <Modal.Title>USER {this.props.editMode.toUpperCase()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    user id&nbsp;<span style={{ color: "red" }} >{this.state.userIdErr}</span>
                                </Form.Text>
                                <Form.Control id="userId" type="text" placeholder="Id" value={this.state.userId} onChange={(e) => this.onFormValueChange(e)} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    name
                                </Form.Text>
                                <Form.Control id="userName" type="text" placeholder="Name" value={this.state.userName} onChange={(e) => this.onFormValueChange(e)} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    description
                                </Form.Text>
                                <Form.Control id="userDescript" type="text" placeholder="Description" value={this.state.userDescript} onChange={(e) => this.onFormValueChange(e)} />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     roles&nbsp;<span style={{ color: "red" }}>{this.state.userRolesErr}</span>
                                </Form.Text>
                                <Select
                                    id="userRoles"
                                    autoFocus
                                    placeholder={"Select user roles"}
                                    options={this.props.roles.map(r => {return {label: r.name, value: r.id}})}
                                    onChange={opts => this.onRoleValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedRoles}
                                />
                            </Form.Group>


                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     locations&nbsp;<span style={{ color: "red" }}>{this.state.userLocationsErr}</span>
                                </Form.Text>
                                <Select
                                    id="userLocations"
                                    autoFocus
                                    placeholder={"Select user locations"}
                                    options={this.props.locations.map(l => {return {label: l.name, value: l.id}})}
                                    onChange={opts => this.onLocationValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedLocations}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     schemas&nbsp;<span style={{ color: "red" }}>{this.state.userSchemasErr}</span>
                                </Form.Text>
                                <Select
                                    id = "userSchemas"
                                    autoFocus
                                    placeholder={"Select user schemas"}
                                    options={this.props.schemas.map(s => {return {label: s.name, value: s.id}})}
                                    onChange={opts => this.onSchemaValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedSchemas}
                                />
                            </Form.Group>
                            



                            <Form.Group className="mb-3">
                                {passwordCheckbox}
                                <Form.Text className="text-muted">
                                    password&nbsp;<span style={{ color: "red" }} >{this.state.userPwdErr}</span>
                                    {showPasswordGenerator}
                                </Form.Text>
                                    <span style={{ display: "flex", flexDirection: "row" }}>
                                    <Form.Control
                                        type={this.state.passwordType} autoComplete="off"
                                        readOnly={!this.state.passwordEditable} 
                                        id="userPwd"
                                        placeholder="Password"
                                        value={this.state.userPwd}
                                        onChange={(e) => this.onFormValueChange(e)}
                                    />
                                    {showPasswordButton}
                                </span>

                                <Form.Text className="text-muted">
                                    re-enter password&nbsp;
                                </Form.Text>
                                <Form.Control
                                    type={this.state.passwordType}
                                    autoComplete="off" readOnly={!this.state.passwordEditable}
                                    id="userPwd2"
                                    placeholder="Password"
                                    value={this.state.userPwd2}
                                    onChange={(e) => this.onFormValueChange(e)}
                                />
                            </Form.Group>

                        </Form>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={(e) => this.postUser(e)}
                    >
                        {workingButtonIcon}
                    </Button>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        //onClick={this.props.closeNewModal}
                        onClick={(e) => this.cancel(e)}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
